import { memo, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { Flex, Skeleton } from 'antd';

import { HeaderMenuTrigger } from '@/widgets/header-menu';
import { AppHeader, AppSider } from '@/widgets/layout';
import { NotificationButton } from '@/widgets/notifications';

import { ChatBot, ChatBotPlaceholderButton } from '@/entities/chat-bot';

import { GlobalDisclamer } from '@/shared/cms/disclamers';
import { getMainPath } from '@/shared/constants/router';
import { Layout } from '@/shared/ui/layout';

interface MainLayoutProps {
    isLoadingUserData: boolean;
}

export const MainLayout = memo((props: MainLayoutProps) => {
    const { isLoadingUserData } = props;

    const { pathname } = useLocation();

    const isMainPath = useMemo(() => pathname === getMainPath(), [pathname]);

    return (
        <>
            <Layout
                bottomSlot={<GlobalDisclamer />}
                headerSlot={
                    <AppHeader
                        rightContentSlot={
                            <Flex
                                align="center"
                                gap={16}
                            >
                                {isMainPath ? (
                                    <Skeleton.Avatar active />
                                ) : (
                                    <>
                                        <NotificationButton />
                                        <ChatBotPlaceholderButton />
                                    </>
                                )}
                                {isMainPath ? (
                                    <Skeleton.Avatar
                                        active
                                        size="large"
                                    />
                                ) : (
                                    <HeaderMenuTrigger />
                                )}
                            </Flex>
                        }
                    />
                }
                isLoading={isLoadingUserData}
                sidebarSlot={<AppSider />}
            />
            {!isMainPath && <ChatBot />}
        </>
    );
});

MainLayout.displayName = 'MainLayout';
